// AuthActions
export const LOGIN_USER_START = 'LOGIN_USER_START';
export const USERNAME_CHANGED = 'USERNAME_CHANGED';
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';
export const LOGIN_RESULT = 'LOGIN_RESULT';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const CLEAR_SESSION_MODAL = 'CLEAR_SESSION_MODAL';
export const SET_SESSION_FROM_STORAGE = 'SET_SESSION_FROM_STORAGE';
export const EXPIRE_SESSION = 'EXPIRE_SESSION';
export const SET_AUTOSCAN_TIMEOUT = 'SET_AUTOSCAN_TIMEOUT';
export const SET_SYSTEM_OVERLAY = 'SET_SYSTEM_OVERLAY';
export const SET_PTZ_CONFIG = 'SET_PTZ_CONFIG';
export const SET_ALL_CAMERAS = 'SET_ALL_CAMERAS';
export const SET_PTZ_PRESETS = 'SET_PTZ_PRESETS';
export const SET_AUTH_SERVERS = 'SET_AUTH_SERVERS';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_USER_RIGHTS = 'SET_USER_RIGHTS';
export const SET_USER_CAMERAS = 'SET_USER_CAMERAS';
export const TOGGLE_EVIEW_LOGIN = 'TOGGLE_EVIEW_LOGIN';
export const SET_EVIEW_LOGIN = 'SET_EVIEW_LOGIN';
// Cloud first-login / admin-reset forced password change: cloudapi /ve/login returns
// { changePassword:true, user } and WITHHOLDS the token until the user sets a new
// password. Carries the user's bID so the change-password screen can call
// /ve/changepassword, and flips loginResult to 'changepw' (see AuthReducer).
export const SET_PW_CHANGE = 'SET_PW_CHANGE';

// NavigationActions
export const SCREEN_CHANGE = 'SCREEN_CHANGE';
export const JUMP_SYSTEM = 'JUMP_SYSTEM';
export const JUMP_SYSTEM_START = 'JUMP_SYSTEM_START';
export const JUMP_SYSTEM_FAILED = 'JUMP_SYSTEM_FAILED';
export const SET_JUMP_ERROR = 'SET_JUMP_ERROR';
// A plain notice that the session's access changed while viewing (AuthActions.refreshCloudAccess).
export const SET_ACCESS_NOTICE = 'SET_ACCESS_NOTICE';

// ServerActions
export const GET_SERVER = 'GET_SERVER';
export const GET_VERSION = 'GET_VERSION';
export const GET_IP = 'GET_IP';
export const GET_NETWORK_STATUS = 'GET_NETWORK_STATUS';
export const SET_EVIEW_MODE = 'SET_EVIEW_MODE';
export const SET_CONTROLLER_MODE = 'SET_CONTROLLER_MODE';
export const SET_CONTROLLER_INFO = 'SET_CONTROLLER_INFO';
export const SET_ALL_SERVERS = 'SET_ALL_SERVERS';
export const SET_ACTIVE_SERVER = 'SET_ACTIVE_SERVER';
export const SET_ENTERPRISE_CAMERAS = 'SET_ENTERPRISE_CAMERAS';
export const SET_ALL_EVIEW_CAMERAS = 'SET_ALL_EVIEW_CAMERAS';
export const SET_SERVER_SESSIONS = 'SET_SERVER_SESSIONS';

// StatusActions
export const SET_MACHINE_STATUS = 'SET_MACHINE_STATUS';
export const SET_USERS_ONLINE = 'SET_USERS_ONLINE';
// Set just the system-name field (state.server.sName) without touching the rest of the
// server config. Used by the CLOUD login (#86bb5dx62) to feed the "Customer — Project"
// account label into the header/breadcrumb/ⓘ; local login fills sName via GET_SERVER.
export const SET_SYSTEM_NAME = 'SET_SYSTEM_NAME';

// ConfButtonsActions
export const CONFIG_CHANGED = 'CONFIG_CHANGED';

// CamButtonsActions
export const CAM_VIEW_CHANGED = 'CAM_VIEW_CHANGED';
export const SET_SINGLE_VIEW = 'SET_SINGLE_VIEW';
export const SET_CAM_BROWSER_CAM = 'SET_CAM_BROWSER_CAM';
export const SET_CAM_GROUP_SINGLE = 'SET_CAM_GROUP_SINGLE';
export const SET_CAM_GROUP_QUAD = 'SET_CAM_GROUP_QUAD';

// ViewActions
export const SET_VIEWS = 'SET_VIEWS';
export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';
export const SET_VIEW_SLOTS = 'SET_VIEW_SLOTS';
export const SAVE_ORIGINAL_CAMERAS = 'SAVE_ORIGINAL_CAMERAS';
export const RESTORE_ORIGINAL_CAMERAS = 'RESTORE_ORIGINAL_CAMERAS';
export const ASSIGN_CAMERA_TO_SLOT = 'ASSIGN_CAMERA_TO_SLOT';
export const SET_VIEW_DIRTY = 'SET_VIEW_DIRTY';
export const CLEAR_VIEW_DIRTY = 'CLEAR_VIEW_DIRTY';
export const SET_VIEW_PRISTINE = 'SET_VIEW_PRISTINE';

//UtilityActions
export const SET_PLATFORM_TYPE = 'SET_PLATFORM_TYPE';
export const SET_BROWSER_TYPE = 'SET_BROWSER_TYPE';
export const UPDATE_CURRENT_TIME = 'UPDATE_CURRENT_TIME';
export const SET_NVR_TIMESTAMP = 'SET_NVR_TIMESTAMP';
export const SET_NVR_TIMEZONE = 'SET_NVR_TIMEZONE';
export const SET_CLOUD_API_VERSION = 'SET_CLOUD_API_VERSION';
export const SET_SERVER_VERSION = 'SET_SERVER_VERSION';

// PlaybackActions
export const RESET_PLAYBACK = 'RESET_PLAYBACK';
export const SET_CAMERA = 'SET_CAMERA';
export const SET_DATE = 'SET_DATE';
export const SET_TIME = 'SET_TIME';
export const SET_VIDEO = 'SET_VIDEO';
export const SET_FILTER = 'SET_FILTER';
export const SET_SPEED = 'SET_SPEED';
export const PLAY = 'PLAY';
export const PAUSE = 'PAUSE';
export const STOP = 'STOP';
export const FAST_FORWARD = 'FAST_FORWARD';
export const STEP_FORWARD = 'STEP_FORWARD';
export const FAST_REVERSE = 'FAST_REVERSE';
export const STEP_REVERSE = 'STEP_REVERSE';
export const UPDATE_PROGRESS_BAR = 'UPDATE_PROGRESS_BAR';
export const TOGGLE_FULLSCREEN_PLAYBACK = 'TOGGLE_FULLSCREEN_PLAYBACK';
export const INCREMENT_CLIPS = 'INCREMENT_CLIPS';
export const DECREMENT_CLIPS = 'DECREMENT_CLIPS';
export const SET_CURRENT_CLIP_PLAYING = 'SET_CURRENT_CLIP_PLAYING';
export const SET_PLAYBACK_SERVER = 'SET_PLAYBACK_SERVER';
export const SET_CLIPS_LOADING = 'SET_CLIPS_LOADING';
export const SET_CLIP_COUNT = 'SET_CLIP_COUNT';

// MCPlaybackActions (MCPlayback — synchronized multi-cam recorded playback)
export const SET_MCPB_CONF = 'SET_MCPB_CONF';
export const SET_MCPB_SLOTS = 'SET_MCPB_SLOTS';
export const SET_MCPB_SLOT_CAMERA = 'SET_MCPB_SLOT_CAMERA';
export const SET_MCPB_TRACK_EVENTS = 'SET_MCPB_TRACK_EVENTS';
export const SET_MCPB_EVENTS_LOADING = 'SET_MCPB_EVENTS_LOADING';
export const SET_MCPB_EVENTS_ERROR = 'SET_MCPB_EVENTS_ERROR';
export const SET_MCPB_SEARCH = 'SET_MCPB_SEARCH';
export const SET_MCPB_PLAYHEAD = 'SET_MCPB_PLAYHEAD';
export const SET_MCPB_EVENT_FLAG = 'SET_MCPB_EVENT_FLAG';
export const RESET_MCPB = 'RESET_MCPB';